// import React, { useState } from 'react';
import styled from 'styled-components/macro';
// import styled, { css } from 'styled-components/macro';

// import Checkbox from '../../UI/Checkbox';
import AssetsSidebar from './Assets/AssetsSidebar';
import AssetsTable from './Assets/AssetsTable';
// import Search from '../../UI/Search';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 45px;

  height: 100%;
`;

const Sidebar = styled.div`
  padding-left: 45px;
  height: 100%;

  border-left: 1px solid ${props => props.theme.bg4};
`;

// const AssetsHeader = styled.header`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;

//   height: 32px;

//   position: relative;
// `;

// const ButtonsWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 8px;
// `;

// const Filters = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 20px;

//   margin-left: auto;
// `;

// const inactiveDisplayButton = css`
//   height: auto;

//   background: transparent;
//   box-shadow: none;

//   color: ${props => props.theme.text1};
// `;

// const DisplayButton = styled.button<{ active?: boolean }>`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   width: auto;
//   height: 32px;
//   padding: 8px 12px;

//   position: relative;

//   background-color: #fff;
//   border-radius: 4px;
//   border: none;
//   box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);

//   color: ${props => props.theme.text0};
//   font-size: 12px;
//   font-weight: 500;

//   cursor: pointer;

//   ${props => !props.active && inactiveDisplayButton};
// `;

// const displayOptions = [
//   {
//     key: 'balances',
//     label: 'Balances',
//   },
// ];

export function AssetsTab() {
  // const [display, setDisplay] = useState('balances');
  // const [expanded, setExpanded] = useState(false);
  // const [query, setQuery] = useState('');

  // const isVisible = expanded ? 'none' : 'inherit';

  // const handleExpanded = (isExpanded: boolean) => {
  //   setExpanded(isExpanded);
  // };

  return (
    <Layout>
      <div>
        {/*<AssetsHeader>
          <ButtonsWrapper style={{ display: isVisible }}>
            {displayOptions.map(button => (
              <DisplayButton
                type="button"
                key={button.key}
                active={display === button.key}
                onClick={() => setDisplay(button.key)}
              >
                {button.label}
              </DisplayButton>
            ))}
          </ButtonsWrapper>
          <Filters style={{ display: isVisible }}>
            <Checkbox label="Favorite" />
            <Checkbox label="Hide zero balances" />
          </Filters>
          <Search
            placeholder="Type to search for assets"
            closeable
            expanded={expanded}
            query={query}
            setExpanded={handleExpanded}
            setQuery={setQuery}
          />
        </AssetsHeader> */}

        <AssetsTable />
      </div>
      <Sidebar>
        <AssetsSidebar />
      </Sidebar>
    </Layout>
  );
}
